(function ($) {
  "use strict";

  /* =========================================================
     DIZZ W OTLUB - HOME PAGE AJAX CART FIX
     Fixes ONLY homepage add-to-cart / mini-cart sync
  ========================================================= */

  if (window.__DIZZ_HOME_CART_AJAX__) {
    return;
  }

  window.__DIZZ_HOME_CART_AJAX__ = true;


  /* =========================================================
     HELPERS
  ========================================================= */

  function shopRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return "/";
  }


  function shopUrl(path) {
    var root = shopRoot();

    if (root.slice(-1) !== "/") {
      root += "/";
    }

    return root + path.replace(/^\/+/, "");
  }


  function isHomePage() {
    var path =
      window.location.pathname
        .replace(/\/+$/, "") || "/";

    return (
      path === "/" ||
      path === "/ar" ||
      path === "/en"
    );
  }


  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }


  /* =========================================================
     BUTTON STATUS
  ========================================================= */

  function setButtonState(button, state) {

    if (!button) return;

    var tooltip =
      button.querySelector(
        ".tp-product-tooltip"
      );

    var cartIcon =
      button.querySelector(
        ".cart_btn_svg"
      );

    var loadingIcon =
      button.querySelector(
        ".loading-icon"
      );


    if (state === "loading") {

      if (tooltip) {
        tooltip.textContent =
          "Adding...";
      }

      if (cartIcon) {
        cartIcon.style.display =
          "none";
      }

      if (loadingIcon) {
        loadingIcon.style.display =
          "";
      }

      return;
    }


    if (state === "success") {

      if (tooltip) {
        tooltip.textContent =
          "Added to cart";
      }

      if (cartIcon) {
        cartIcon.style.display =
          "";
      }

      if (loadingIcon) {
        loadingIcon.style.display =
          "none";
      }

      return;
    }


    if (tooltip) {
      tooltip.textContent =
        "Add to cart";
    }

    if (cartIcon) {
      cartIcon.style.display =
        "";
    }

    if (loadingIcon) {
      loadingIcon.style.display =
        "none";
    }
  }


  /* =========================================================
     GET REAL SHOPIFY CART
  ========================================================= */

  async function getRealCart() {

    var response = await fetch(
      shopUrl("cart.js") +
      "?dizz=" +
      Date.now(),
      {
        credentials: "same-origin",
        cache: "no-store",
        headers: {
          "Cache-Control":
            "no-cache"
        }
      }
    );


    if (!response.ok) {

      throw new Error(
        "Unable to read cart"
      );

    }


    return await response.json();
  }


  /* =========================================================
     UPDATE HEADER COUNT
  ========================================================= */

  function updateCartCount(cart) {

    if (!cart) return;


    document
      .querySelectorAll(
        ".cart-count, " +
        ".tp-header-action-badge, " +
        "[data-cart-count]"
      )
      .forEach(function (element) {

        element.textContent =
          cart.item_count;

      });


    var total =
      document.querySelector(
        "header-total-price"
      );


    if (
      total &&
      typeof total.updateTotal ===
        "function"
    ) {

      total.updateTotal(cart);

    }
  }


  /* =========================================================
     COPY FRESH HTML
  ========================================================= */

  function syncElements(
    selector,
    freshDocument
  ) {

    var currentElements =
      Array.from(
        document.querySelectorAll(
          selector
        )
      );


    var freshElements =
      Array.from(
        freshDocument.querySelectorAll(
          selector
        )
      );


    if (
      !currentElements.length ||
      !freshElements.length
    ) {
      return false;
    }


    currentElements.forEach(
      function (current, index) {

        var fresh =
          freshElements[index] ||
          freshElements[0];


        if (fresh) {

          current.innerHTML =
            fresh.innerHTML;

        }

      }
    );


    return true;
  }


  /* =========================================================
     REFRESH MINI CART FROM SERVER
  ========================================================= */

  async function refreshMiniCart() {

    /*
      نجيب صفحة /cart كاملة من Shopify
      بعد نجاح الإضافة.

      الصفحة دي تحتوي Mini Cart
      الحقيقي بعد تحديث السلة.
    */

    var response = await fetch(
      shopUrl("cart") +
      "?dizz_refresh=" +
      Date.now(),
      {
        credentials: "same-origin",
        cache: "no-store",
        headers: {
          "Cache-Control":
            "no-cache"
        }
      }
    );


    if (!response.ok) {

      throw new Error(
        "Unable to refresh mini cart"
      );

    }


    var html =
      await response.text();


    var freshDocument =
      new DOMParser()
        .parseFromString(
          html,
          "text/html"
        );


    /*
      الأول نحاول تحديث الفورم نفسه.
    */

    var formUpdated =
      syncElements(
        "#form-mini-cart",
        freshDocument
      );


    /*
      لو الثيم عنده Mini Cart
      بطريقة ثانية نستخدم widget.
    */

    if (!formUpdated) {

      syncElements(
        ".cartmini__widget",
        freshDocument
      );

    }


    /*
      تحديث السعر أسفل السلة
    */

    syncElements(
      ".cartmini__checkout-price",
      freshDocument
    );


    /*
      تحديث Subtotal إن وجد
    */

    syncElements(
      ".cartmini__checkout-title",
      freshDocument
    );


    /*
      تحديث Free Shipping إن وجد
    */

    var currentShipping =
      document.querySelector(
        ".cart_shipping"
      );


    var freshShipping =
      freshDocument.querySelector(
        ".cart_shipping"
      );


    if (
      currentShipping &&
      freshShipping
    ) {

      currentShipping.innerHTML =
        freshShipping.innerHTML;

      currentShipping.className =
        freshShipping.className;

    }


    /*
      تحديث العدد الحقيقي أيضًا
    */

    var cart =
      await getRealCart();


    updateCartCount(cart);


    return cart;
  }


  /* =========================================================
     ADD PRODUCT - HOME PAGE
  ========================================================= */

  async function addHomeProduct(form) {

    if (
      !form ||
      form.dataset.dizzBusy === "1"
    ) {
      return;
    }


    form.dataset.dizzBusy =
      "1";


    var button =
      form.querySelector(
        ".add-product-cart-btn"
      );


    setButtonState(
      button,
      "loading"
    );


    try {

      var formData =
        new FormData(form);


      /*
        إضافة المنتج مرة واحدة فقط
        مباشرة إلى Shopify.
      */

      var addResponse =
        await fetch(
          shopUrl("cart/add.js"),
          {
            method: "POST",
            body: formData,
            credentials:
              "same-origin",
            headers: {
              Accept:
                "application/json"
            }
          }
        );


      if (!addResponse.ok) {

        var errorMessage =
          "Add to cart failed";


        try {

          var errorData =
            await addResponse.json();


          if (
            errorData &&
            errorData.description
          ) {

            errorMessage =
              errorData.description;

          }

        } catch (e) {}


        throw new Error(
          errorMessage
        );

      }


      await addResponse.json();


      /*
        بمجرد انتهاء cart/add.js
        Shopify يكون حدث السلة.
      */

      var cart =
        await getRealCart();


      updateCartCount(cart);


      /*
        مهلة صغيرة جدًا فقط
        قبل جلب HTML الجديد.
      */

      await wait(100);


      await refreshMiniCart();


      setButtonState(
        button,
        "success"
      );


      setTimeout(
        function () {

          setButtonState(
            button,
            "normal"
          );

        },
        1200
      );


    } catch (error) {

      console.error(
        "DIZZ HOME CART ERROR:",
        error
      );


      setButtonState(
        button,
        "normal"
      );


    } finally {

      setTimeout(
        function () {

          form.dataset.dizzBusy =
            "0";

        },
        400
      );

    }
  }


  /* =========================================================
     IMPORTANT:
     CAPTURE HOME-PAGE CART BUTTON BEFORE OTHER SCRIPTS
  ========================================================= */

  document.addEventListener(
    "click",
    function (event) {

      if (!isHomePage()) {
        return;
      }


      var button =
        event.target.closest(
          ".add-product-cart-btn"
        );


      if (!button) {
        return;
      }


      var form =
        button.closest(
          "form.add-to-cart-rendom"
        );


      if (!form) {
        return;
      }


      /*
        نوقف أي Add-to-Cart script
        ثاني من إرسال المنتج مرة ثانية.
      */

      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      addHomeProduct(form);

    },
    true
  );


  /*
    احتياط لو تم إرسال الفورم
    عن طريق Enter بدل الضغط.
  */

  document.addEventListener(
    "submit",
    function (event) {

      if (!isHomePage()) {
        return;
      }


      var form =
        event.target;


      if (
        !form ||
        !form.matches(
          "form.add-to-cart-rendom"
        )
      ) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      addHomeProduct(form);

    },
    true
  );


  /* =========================================================
     REFRESH CART WHEN OPENING IT
  ========================================================= */

  document.addEventListener(
    "click",
    function (event) {

      if (!isHomePage()) {
        return;
      }


      var cartButton =
        event.target.closest(
          ".cartmini-open-btn, " +
          ".tp-header-action-cart, " +
          ".tp-header-action-btn"
        );


      if (!cartButton) {
        return;
      }


      /*
        لا نمنع فتح السلة.
        فقط نضمن أن بياناتها حديثة.
      */

      refreshMiniCart()
        .catch(function (error) {

          console.log(
            "DIZZ CART OPEN REFRESH:",
            error
          );

        });

    },
    true
  );


  /* =========================================================
     ORIGINAL MINI CART REMOVE
  ========================================================= */

  $(document).ready(
    function () {

      $(document).on(
        "click",
        "mini-cart-remove-button",
        function (e) {

          e.preventDefault();


          var $this =
            $(this);


          var index =
            $this.data(
              "index"
            );


          var id =
            $this.data(
              "varient-id"
            );


          var data = {
            index: index,
            id: id,
            quantity: 0
          };


          $.ajax({

            type: "post",

            url:
              shopUrl(
                "cart/change.js"
              ),

            data: data,


            success:
              function () {

                refreshMiniCart()
                  .catch(
                    function (
                      error
                    ) {

                      console.log(
                        error
                      );

                    }
                  );

              }

          });

        }
      );


      /* =====================================================
         COMPARE - ORIGINAL
      ===================================================== */

      $(document).on(
        "click",
        ".tps__compare-remove-js",
        function (e) {

          e.preventDefault();


          var id =
            $(this).data(
              "product-handle"
            );


          var compare_products =
            JSON.parse(
              localStorage.getItem(
                "tps__compare-items"
              )
            ) || [];


          compare_products =
            compare_products.filter(
              function (item) {

                return item !== id;

              }
            );


          localStorage.setItem(
            "tps__compare-items",
            JSON.stringify(
              compare_products
            )
          );


          window.location.reload();

        }
      );


      /* =====================================================
         WISHLIST - ORIGINAL
      ===================================================== */

      $(document).on(
        "click",
        ".remove_item_wishlist",
        function (e) {

          e.preventDefault();


          var id =
            $(this).data(
              "product-handle"
            );


          var wishlist_products =
            JSON.parse(
              localStorage.getItem(
                "tps__wishlist-items"
              )
            ) || [];


          $(this)
            .closest("tr")
            .remove();


          wishlist_products =
            wishlist_products.filter(
              function (item) {

                return item !== id;

              }
            );


          localStorage.setItem(
            "tps__wishlist-items",
            JSON.stringify(
              wishlist_products
            )
          );

        }
      );

    }
  );

})(jQuery);